<template>
<v-toolbar class="AppBar" height="100px">
    <v-container>
        <v-row class="d-flex pl-0">
            <v-col cols="12" sm="8" class="mt-0 pt-0 pb-0">

                <v-breadcrumbs class="pl-3" :items="breadCrumbs" divider=">"></v-breadcrumbs>

            </v-col>

            <!-- <v-col cols="12" sm="4" align="right" class="pt-1">
                <v-spacer></v-spacer>
                <v-btn color="primary" text href="http://www.econeteditora.com.br/?url=consultoria_antigo/?acao=home" target="_blank">
                    Abrir versão anterior
                    <v-icon class="ml-2">mdi-history</v-icon>
                </v-btn>
            </v-col> -->

        </v-row>
        <v-row class="mt-0">
            <v-col cols="12" sm="8" class="mt-0 pt-0 pb-0">

                <h1 class="text-h5 font-weight-bold pt-2">
                    Consulta por E-mail
                </h1>

            </v-col>

            <v-col cols="12" sm="4" align="right" class="pt-1">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="novaConsulta()" align="center">
                    <span>
                        Iniciar Nova Consulta
                    </span>
                    <v-icon small>
                        mdi-plus
                    </v-icon>
                </v-btn>
            </v-col>

        </v-row>

    </v-container>

</v-toolbar>
</template>

<script>
export default {

    name: "CoreAppBar",
    components: {

    },

    data: () => ({
        showLogo: false,
        isScrolling: false,
        breadCrumbs: [{
                text: 'Minhas consultas',
                disabled: false,
                to: '/',
            },

        ],
        abrirNovaConsulta: {
            intOpcao: 0,
            strAcao: null
        },
        obDados: {
            'mensagem': 'teste'
        }
    }),
    mounted() {
        this.updateBreadCrumbs();
    },
    computed: {
        currentConsulta() {
            return this.$root.$store.state.currentConsulta.intIndice
        },
        urlMinhasConsultas() {
            // console.log(document.location.pathname)
            // const regex = /(listar-consulta\/\d+)/gm;
            // const str = document.location.pathname
            // const subst = ``;
            // const result = str.replace(regex, subst);

            return '/'
        }
    },
    watch: {
        $route(to, from) {
            this.show = false;
            //this.updateBreadCrumbs()

            // console.log(to.path)
            if (to.path === '/') {
                this.$root.$store.state.currentConsulta = {
                    'intIndice': ''
                }
                this.breadCrumbs = [{
                    text: 'Minhas consultas',
                    disabled: false,
                    to: this.urlMinhasConsultas,
                }, ]
            }
        },
        currentConsulta: function () {

            this.updateBreadCrumbs()
            //  console.log('a current consulta foi modificada', this.currentConsulta)
        }
    },
    methods: {
        onScroll() {
            const offset = window.pageYOffset;
            this.isScrolling = offset > 50;
            this.showLogo = offset > 200;
        },
        novaConsulta() {
            this.$root.$store.state.abrirNovaConsulta = true
        },
        updateBreadCrumbs() {

            let idGet = "Consulta #" + this.currentConsulta

            this.breadCrumbs = [{
                text: 'Minhas consultas',
                disabled: false,
                to: this.urlMinhasConsultas,
            }, ]

            if (this.$route.params.id && this.checkItemExist() == false && this.currentConsulta !== '') {

                this.breadCrumbs.push({
                    text: idGet,
                    disabled: true,
                    to: './'
                })
            }
            if (!this.$route.params.id) {
                this.breadCrumbs = [{
                        text: 'Minhas consultas',
                        disabled: false,
                        to: this.urlMinhasConsultas,
                    },

                ]
            }
        },
        checkItemExist() {
            // console.log(this.breadCrumbs)
            return this.breadCrumbs.some(item => item.text === 'Consulta #' + this.currentConsulta)
        }

    },

};
</script>

<style lang="scss">
@import "./AppBar.scss";
</style>
